export const GOOGLE_ANALYTICS = "UA-122613642-6";
export const GOOGLE_ADS_CLIENT = "ca-pub-3265727260204834";
export const GOOGLE_ADS_SLOTS = ["6517180577", "1792768244"] as const;
export const LOG_TOKEN = "d5(TaY(G*Z*C6T88_bz)9n6rus.vN4H-/gufqntxmg128";
export const STRIPE_TEST_PUBLIC_KEY =
    "pk_test_51LhhV3HweUPlZUIvprAPWnuvtH8SbyRzeIrS7unJzGNPN2ya3zVdrMmiCS0ByNJmFM8zyWdNPmTex0xVU9qnfGNp00HuzjH6Mj";
export const STRIPE_PRODUCTION_PUBLIC_KEY =
    "pk_live_51LhhV3HweUPlZUIvope4FfZ0jeF2hoOzoIkDKBKN7JDFItTSh2MzVkgpcje7MucjuzWAb9W2ToobUp3FW9CoVURg00oQmqnWcW";
